import { object } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'

const imageClasses = (logoAlignment) =>
  kuiperClassNames('logo', {
    'align-right': logoAlignment === 'right',
  })

const SlideThumbnailHeader = ({ theme }) => {
  const {
    header_background_color: headerBackgroundColor,
    logo_alignment: logoAlignment,
    logo,
  } = theme

  return (
    <div
      className={kuiperClassNames('header')}
      style={{ backgroundColor: headerBackgroundColor }}
    >
      {logo && (
        <img
          alt="Custom Slide Logo"
          className={imageClasses(logoAlignment)}
          src={`${logo}`}
        />
      )}
    </div>
  )
}

SlideThumbnailHeader.propTypes = {
  theme: object,
}

SlideThumbnailHeader.defaultProps = {
  theme: {},
}

export default SlideThumbnailHeader
